import styled from "styled-components";
import { colours } from "../../../../../../../styles/colours.constants";
import {
	satoshi500,
	satoshi700,
} from "../../../../../../../styles/font.constants";

export const Menu = styled.div`
	position: fixed;
	z-index: 10000;
	width: ${272 - 2}px;
	max-height: 15rem;
	overflow-y: auto;
	background: ${colours.white};
	border: 1px solid ${colours.greyDark};
	border-radius: 0.75rem;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
	padding: 0.4rem;
`;

export const Section = styled.div`
	&:not(:first-child) {
		margin-top: 0.4rem;
	}
`;

export const SectionLabel = styled.div`
	${satoshi700}
	color: ${colours.greyDarker};
	font-size: 0.7rem;
	text-transform: uppercase;
	letter-spacing: 6%;
	padding: 0.35rem 0.5rem 0.2rem;
`;

export const Item = styled.button<{ $active: boolean }>`
	display: flex;
	align-items: center;
	gap: 0.6rem;
	width: 100%;
	border: none;
	border-radius: 0.5rem;
	padding: 0.45rem 0.5rem;
	background: ${({ $active }) => ($active ? colours.greyLight : "transparent")};
	cursor: pointer;
	text-align: left;
`;

export const Swatch = styled.span`
	flex-shrink: 0;
	width: 0.6rem;
	height: 0.6rem;
	border-radius: 50%;
`;

export const Name = styled.span`
	${satoshi500}
	color: ${colours.black}D9;
	font-size: 0.95rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const Meta = styled.span`
	${satoshi500}
	color: ${colours.black}80;
	font-size: 0.8rem;
	white-space: nowrap;
	margin-left: auto;
	padding-left: 0.5rem;
`;
